import { AppearanceSetting } from "../AccountSettings";

/**
 * Appearance: one radio group, unchanged.
 *
 * It was already a real preference applied immediately and remembered, so this
 * panel adds nothing to it. Its own category rather than a row inside Account
 * because it is the setting people come looking for by name.
 */
export function AppearancePanel() {
  return <AppearanceSetting />;
}
